module.exports = __webpack_public_path__ + "img/reward_content_title_1.b0c531e5.png";